import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
const mount = () =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

/* Paint first, mount second. On the homepage the static shell (index.html) already shows the header and
   hero. We let its hero photo + marble texture finish loading (capped at 1.5s) and give the browser two
   frames to actually paint them before React takes over, so the largest paint is never held back by
   JavaScript. Other routes mount immediately. */
const onHome = !document.documentElement.classList.contains("fp-not-home");
const heroImg = onHome ? document.querySelector("#fp-shell-hero img") : null;

if (heroImg) {
  const marble = new Image();
  marble.src = "/textures/marble.webp";
  const settle = (img) =>
    new Promise((resolve) => {
      if (img.complete) return resolve();
      img.addEventListener("load", resolve, { once: true });
      img.addEventListener("error", resolve, { once: true });
    });
  const twoFrames = () => new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  Promise.race([
    Promise.all([settle(heroImg), settle(marble)]).then(twoFrames),
    new Promise((resolve) => setTimeout(resolve, 1500)),
  ]).then(mount);
} else {
  mount();
}
